import { render, staticRenderFns } from "./ModifyPwd.vue?vue&type=template&id=34551dd2&scoped=true&"
import script from "./ModifyPwd.vue?vue&type=script&lang=js&"
export * from "./ModifyPwd.vue?vue&type=script&lang=js&"
import style0 from "./ModifyPwd.vue?vue&type=style&index=0&id=34551dd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34551dd2",
  null
  
)

export default component.exports